import {Button, Div, HeaderBack, ImageView, Label} from 'components';
import {Ecolors, Efonts, Icons, stringApp} from 'constant';
import React, {useEffect, useState} from 'react';
import {
  getInvestmentProfile,
  getStatusEditBankInfo,
  getStatusEditProfile,
} from 'reducer/authen/selector';
import {navigate} from 'services';
import {doGetAxios} from 'services/apis/axios';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {Log, removeUtf8} from 'utils';
import ItemCard from './ItemCard';
import {getInfo} from 'reducer/authen';
import {convertchangeIdNoStatus} from '../ChangeCMNDtoCCCDScreen/api';

function RowSpaceItem(p: {paddingTop?: number; children?: any}) {
  return (
    <Div
      minHeight={54}
      paddingHorizontal={16}
      borderBottomWidth={1}
      borderBottomColor={Ecolors.spaceColor}
      paddingVertical={10}
      // paddingTop={p.paddingTop ?? 0}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}>
      {p.children && p.children}
    </Div>
  );
}

function BankInfoModal() {
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const investmentProfile = useAppSelector(state =>
    getInvestmentProfile(state),
  );
  const [branch, setBranch] = useState<any>(null);
  const isEdit = useAppSelector(state => getStatusEditBankInfo(state));
  const [incomeSourceString, setIncomeSourceString] = useState<string>('');
  const [annualIncomeString, setAnnualIncomeString] = useState<string>('');
  const dispatch = useAppDispatch();
  const {bankAccount, changeBankInfoStatus, bankAccountIsFull, changeBankInfo} =
    currentUser;

  useEffect(() => {
    bindStringApp();
    dispatch(getInfo({}));
    return () => {};
  }, []);

  useEffect(() => {
    getDataBranch(bankAccount?.branchId);
    return () => {};
  }, [bankAccount?.branchId]);

  const getDataBranch = async (r: number | string) => {
    const res = await doGetAxios(
      `bank/branch/list?bankId=${bankAccount?.bankId}`,
    );
    if (res.status == 200) {
      const t = res.data.find((a: any) => a.id == bankAccount?.branchId);
      if (t) {
        setBranch(t);
      }
    }
  };

  const bindStringApp = () => {
    setIncomeSourceString(
      stringApp.source.find(a => a.id == bankAccount?.incomeSource)?.name || '',
    );
    setAnnualIncomeString(
      stringApp.monthlyIncom.find(a => a.id == bankAccount?.annualIncome)
        ?.name || '',
    );
  };

  const iconEdit = () => {
    const currentProfileStatus = investmentProfile?.status?.code;

    const statuses = [
      'INVESTMENT_PROFILE_ACCEPT',
      'INVESTMENT_PROFILE_APPROVE',
    ];

    const isProfileApproved = statuses.includes(currentProfileStatus);

    if (
      !bankAccountIsFull || // Mới tạo account, chưa điền đầy đủ thông tin
      (isProfileApproved && changeBankInfo == 1) || // Đã xác thực và trạng thái là approved hoặc reject
      !currentProfileStatus // Chưa xác thực
    ) {
      return Icons.edit;
    }
    return null;
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        type={2}
        iconRight={iconEdit()}
        title={`accountverify.thongtinnganhang`}
        onRightPress={() => {
          navigate('EditBankInfoModal');
        }}
      />
      {!!changeBankInfoStatus && (
        <Button
          onPress={() => {
            navigate('ChangeCMNDtoCCCDDetailsScreen', {change: 'bank'});
          }}>
          <RowSpaceItem>
            <Label>{`changecmnd.trangthaihoso`}</Label>
            <Div
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end">
              <Label
                fontFamily={Efonts.italic}
                color={convertchangeIdNoStatus(changeBankInfoStatus).color}
                multilanguage={false}>
                {convertchangeIdNoStatus(changeBankInfoStatus).title}
              </Label>
              <ImageView
                marginLeft={5}
                widthHeight={12}
                source={Icons.forward}
                resizeMode="contain"
              />
            </Div>
          </RowSpaceItem>
        </Button>
      )}
      <ItemCard
        title={`accountverify.tenchutaikhoan`}
        content={removeUtf8(
          bankAccount?.name?.toLocaleUpperCase() ||
            currentUser?.name?.toLocaleUpperCase(),
        )}
        isLine={true}
      />
      <ItemCard
        title={`accountverify.sotaikhoan`}
        content={bankAccount?.number || ' '}
        isLine={true}
      />
      <ItemCard
        title={`accountverify.tennganhang`}
        content={bankAccount?.bankName || ' '}
        isLine={true}
      />
      <ItemCard
        title={`accountverify.chinhanh`}
        content={
          bankAccount?.branchId
            ? branch?.name || ''
            : bankAccount?.bankName || ' '
        }
        isLine={true}
      />
      {currentUser?.bankAccountIsFull && (
        <>
          <ItemCard
            title={`accountverify.nghenghiep`}
            content={bankAccount?.job || '_'}
            isLine={true}
          />
          <ItemCard
            title={`accountverify.chucvu`}
            content={bankAccount?.position || '_'}
            isLine={true}
          />
          <ItemCard
            title={`accountverify.mucthunhaphangthang`}
            content={annualIncomeString || '_'}
            isLine={true}
          />
          <ItemCard
            title={`accountverify.nguontiendautu`}
            content={incomeSourceString || '_'}
            isLine={true}
          />
        </>
      )}
    </Div>
  );
}

export default React.memo(BankInfoModal);
